export const GOOGLE_SEARCH_ENGINE = "google";
export const WIDGET_TITLE_KEY = "keyword.analysis.overview.page.v2.keyword_ideas.title";
export const WIDGET_TOOLTIP_KEY = "keyword.analysis.overview.page.v2.keyword_ideas.tooltip";
const RELATED_ENDPOINT = "api/googleKeywordGenerator/related";
export const ENDPOINT = "api/KeywordGenerator/google/suggest";
export const CTA_NAVIGATION_STATE = "digitalsuite_findkeywords_keywordGeneratorTool";
export const TABLE_SELECTION_KEY = "KeywordIdeasTable";
export const TABLE_SELECTION_PROPERTY = "keyword";
export const ROW_COUNT = 5;
